var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_wrap"},[_c('Navbar'),_c('tags-view',{on:{"nav_state":_vm.nav_state}}),_c('div',{staticClass:"app_body",class:_vm.main_left?'body_right':'body_left'},[_c('app-main')],1),(_vm.look)?_c('Drawer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }